module.exports = __webpack_public_path__ + "img/banner201.ba72258c.jpeg";